// extracted by mini-css-extract-plugin
module.exports = {"subscription-link":"styles-m__subscription-link__YhFTS","text":"styles-m__text__1o5me"};